import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { FluctuationActionButton } from './components/fluctuation-action-button';
import { ActionSubPanel } from './constants';
import { getDefaultDismissOptions, getDefaultFeedbackOptions } from './utils';
import { DismissForm, FeedbackForm } from './components/insight-action-forms';

export class InsightAction extends React.PureComponent {
  constructor(props) {
    super(props);
    const { i18n } = this.props.deps;
    this.feedbackOptions = this.props.feedbackOptions || getDefaultFeedbackOptions(i18n);
    this.dismissFeedbackOptions = this.props.dismissOptions || getDefaultDismissOptions(i18n);

    this.state = {
      comment: '',
      selectedCheckboxes: [],
    };
  }

  showPanel = (panel) => {
    const newPanel = panel === this.props.activeSubPanel ? ActionSubPanel.None : panel;
    this.setState(
      {
        selectedCheckboxes: [],
        comment: '',
      },
      this.props.onCurrentSubPanelChange(newPanel)
    );
  };

  toggleCheckbox = ({ target }, checked) => {
    const { id } = target;
    this.setState({
      selectedCheckboxes: checked ? this.state.selectedCheckboxes.concat(id) :
        _.without(this.state.selectedCheckboxes, id),
    });
  };

  cancelAction = (event) => {
    event.stopPropagation();
    this.props.onCurrentSubPanelChange(ActionSubPanel.None);
  };

  submitActionFeedback = (event) => {
    event.stopPropagation();
    const feedbackObj = {
      feedbacks: this.state.selectedCheckboxes,
      comment: this.state.comment,
      type: this.props.activeSubPanel,
    };
    const newSubPanel = this.showFeedbackForm ?
      ActionSubPanel.FeedbackComplete : ActionSubPanel.None;
    this.props.onCurrentSubPanelChange(newSubPanel);
    this.props.onSubmit(feedbackObj);
  };

  handleCommentChange = ({ target }) => {
    this.setState({ comment: target.value });
  };

  render() {
    const { deps: { i18n } } = this.props;
    this.showFeedbackForm = this.props.activeSubPanel === ActionSubPanel.FeedbackPanel;
    this.showDismissForm = this.props.activeSubPanel === ActionSubPanel.DismissPanel;
    this.feedbackSubmitted = this.props.activeSubPanel === ActionSubPanel.FeedbackComplete;

    const actionFormCommonProps = {
      i18n,
      CommentContainer: this.commentContainer,
      onSubmit: this.submitActionFeedback,
      onCancel: this.cancelAction,
      toggleCheckbox: this.toggleCheckbox,
      handleCommentChange: this.handleCommentChange,
    };

    return (
      <div className="fluctuation-action-container">
        <div className="action-container">
          <LearnMoreLink
            topic={this.props.learnMoreLinkTopic}
            linkText={i18n.getString('Fluctuation_Option_help')}
          />
          {_.map(this.props.subPanels, panel => (
            <FluctuationActionButton
              i18n={i18n}
              actionType={panel}
              onClick={() => this.showPanel(panel)}
              key={panel}
            />))}
        </div>
        {this.showFeedbackForm &&
        <FeedbackForm
          {...actionFormCommonProps}
          checkboxOption={this.feedbackOptions}
          comment={this.state.comment}
          selectedCheckboxes={this.state.selectedCheckboxes}
        /> }
        {this.showDismissForm &&
        <DismissForm
          {...actionFormCommonProps}
          checkboxOption={this.dismissFeedbackOptions}
        />}
        {this.feedbackSubmitted &&
        <div className="feedback-complete">
          {this.props.deps.i18n.getString('Fluctuation_feedback_complete')}
        </div>}
      </div>
    );
  }
}

InsightAction.propTypes = {
  deps: PropTypes.shape({
    i18n: PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCurrentSubPanelChange: PropTypes.func.isRequired,
  activeSubPanel: PropTypes.string.isRequired,
  feedbackOptions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
    name: PropTypes.string,
  })),
  dismissOptions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
    name: PropTypes.string,
  })),
  learnMoreLinkTopic: PropTypes.string,
  subPanels: PropTypes.arrayOf(PropTypes.string),
};

InsightAction.defaultProps = {
  feedbackOptions: undefined,
  dismissOptions: undefined,
  learnMoreLinkTopic: 'app54666',
  subPanels: [ActionSubPanel.FeedbackPanel, ActionSubPanel.DismissPanel],
};
